import ZMC from "components/Stacker/constants/ZoomModalConstants"

export const initialState = { isZoomed: true, scale: 1 }

export default function zoomModalReducer(previousState = initialState, action) {
  switch (action.type) {
    case ZMC.ZOOM_MODAL_UPDATE_SLIDE:
      return {
        ...previousState,
        selectedIndex: action.payload,
      }
    case ZMC.ZOOM_MODAL_DESTROY:
      return initialState
    case ZMC.ZOOM_MODAL_ZOOM_IN:
      return {
        ...previousState,
        isZoomed: true,
        scale: action.payload,
      }
    case ZMC.ZOOM_MODAL_ZOOM_OUT:
      return {
        ...previousState,
        isZoomed: false,
        scale: action.payload,
      }
    default:
      return previousState
  }
}
